import { host } from "../../config/Config"
import React from 'react';
import "./style/style-mob.css";
import { useNavigate } from "react-router-dom";

export const UserRegistration = () => {
    const [name, setName] = React.useState(""); 
    const [phone, setPhone] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [error, setError] = React.useState("");
    const [unosError, setUnosError] = React.useState("");
    const navigate = useNavigate();

    const handlePocetna = () => {
        navigate("/");
    }

    const handleLogin = () => {
        navigate("/user-login");
    }

    const handleRegistration = async () => {
        try {
            if (name.length == 0) {
                setUnosError(".")
                setName("")
                return;
            } else if (phone.length == 0) {
                setUnosError(".")
                setPhone("")
                return;
            } else if (password.length == 0) {
                setUnosError(".")
                setPassword("")
                return;
            }
            const response = await fetch(`${host}/api/v1/auth/register-user`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ 
                    name: name,
                    phone: phone,
                    password: password
                 })
            });

            const res = await response.json();

            if (response.ok) {
                localStorage.setItem("zajednica-token", res.token);
                localStorage.setItem("zajednica-name", res.name);
                localStorage.setItem("zajednica-phone", res.phone);
                setUnosError("");
                setError("");
                navigate("/profile");
            } else {
                setPhone("");
                setError(".");
            }
        } catch (error) {
            setPassword("");
            setError("Došlo je do greške.");
        }
    };

    return (
        <div className="barber-zajednica-admin-page">
            <div className="barber-zajednica-admin-background"></div>
            <h1>Registracija</h1>
            <input
                type="text"
                style={{marginTop: "-10px", fontSize: "30px"}}
                placeholder={unosError ? 'Unesi Ime i Prezime' : 'Ime i Prezime'}
                className={unosError ? "barber-zajednica-input-password-invalid" : "barber-zajednica-input-password"}
                value={name}
                onChange={(e) => setName(e.target.value)}
            />

            <input
                type="number"
                style={{marginTop: "30px", fontSize: "30px"}}
                placeholder={'Telefon (06* ****** )'}
                className={unosError ? "barber-zajednica-input-password-invalid" : "barber-zajednica-input-password"}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
            />  

            <input
                type="password"
                style={{marginTop: "30px", fontSize: "30px"}}
                placeholder={'Unesi lozinku'}
                className={unosError ? "barber-zajednica-input-password-invalid" : "barber-zajednica-input-password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />

            {error && <p style={{marginTop: "30px", color: "#961515"}}>Korisnik sa tim brojem</p>}
            {error && <p style={{color: "#961515"}}>telefona vec postoji</p>}

            <button className="barber-zajednica-login-button-user" onClick={handleRegistration} style={{marginTop: "40px"}}>
                Registruj se
            </button>
            <button className="barber-zajednica-login-button-user" onClick={handlePocetna} style={{marginTop: "30px"}}>
                Početna strana
            </button>
            <p style={{fontSize: "25px", marginTop: "40px", zIndex: "100"}} onClick={handleLogin}>
                Već imaš nalog ? 
            </p>
            <p style={{fontSize: "25px",  zIndex: "100"}} onClick={handleLogin}>
                Klikni ovde
            </p>
        </div>
    );
};
